import React from 'react';
import { motion } from 'framer-motion';

const JSSolutionLogo = ({ 
  size = 'md', 
  animated = false, 
  className = '',
  showText = false 
}) => {
  const sizes = {
    xs: 'w-6 h-6',
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24',
    '2xl': 'w-32 h-32',
    '3xl': 'w-48 h-48',
    hero: 'w-64 h-64'
  };

  const logoElement = (
    <img 
      src="/js-solution-logo.png" 
      alt="JS Solution"
      className={`${sizes[size] || sizes.md} object-contain drop-shadow-[0_2px_6px_rgba(0,0,0,0.35)] ${className}`}
    />
  );

  if (animated) {
    return (
      <motion.div
        initial={{ scale: 0, rotate: -180 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ 
          type: 'spring', 
          stiffness: 260, 
          damping: 20,
          duration: 0.8 
        }}
        whileHover={{ 
          scale: 1.05,
          transition: { duration: 0.3 }
        }}
        className="relative"
      >
        {logoElement}
      </motion.div>
    );
  }

  return logoElement;
};

export default JSSolutionLogo;
